import { Image, Music } from 'lucide-vue-next';
import MediaPanel from '@/components/panels/MediaPanel.vue';
import type { PanelOpener } from '@/composables/use-panels.js';
import { createFileIconComponent } from '@/lib/file-icons.js';

const IMAGE_EXTENSIONS = new Set([
	'.png',
	'.jpg',
	'.jpeg',
	'.gif',
	'.webp',
	'.svg',
	'.bmp',
	'.ico',
	'.avif',
]);
const VIDEO_EXTENSIONS = new Set(['.mp4', '.webm', '.ogg', '.mov']);
const AUDIO_EXTENSIONS = new Set(['.mp3', '.wav', '.flac', '.aac', '.oga', '.weba', '.m4a']);

export const createMediaOpener = (): PanelOpener => ({
	scheme: 'file',
	priority: 10,
	defaultRegion: 'center',
	allowedRegions: ['center', 'bottom'],
	resolve(uri) {
		const path = uri.slice('file://'.length);
		const name = path.split('/').pop() ?? path;
		const ext = ('.' + (name.split('.').pop() ?? '')).toLowerCase();
		// decline non-media files — let the next file opener handle them
		if (!IMAGE_EXTENSIONS.has(ext) && !VIDEO_EXTENSIONS.has(ext) && !AUDIO_EXTENSIONS.has(ext)) {
			return null;
		}
		const fallbackIcon = AUDIO_EXTENSIONS.has(ext) ? Music : Image;
		return {
			uri,
			title: name,
			icon: createFileIconComponent(name) ?? fallbackIcon,
			component: MediaPanel,
			props: { path },
			closable: true,
		};
	},
});
